export const MIN_SLIDE_COUNT = 3;

export const DEFAULT_AUTO_SCROLL_COUNT = 4000;

export const pointers_scroll_container_id = "link-panel-pointers";

export const single_pointer_margin = 28;
